<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16.0003 29.3333C23.3641 29.3333 29.3337 23.3638 29.3337 16C29.3337 8.63621 23.3641 2.66667 16.0003 2.66667C8.63653 2.66667 2.66699 8.63621 2.66699 16C2.66699 23.3638 8.63653 29.3333 16.0003 29.3333Z"
    fill="#47675B"
  />
  <path
    d="M10.667 18.6667C10.667 18.6667 12.667 21.3333 16.0003 21.3333C19.3337 21.3333 21.3337 18.6667 21.3337 18.6667"
    fill="#47675B"
  />
  <path
    d="M20.667 12C20.667 12.3682 20.3685 12.6667 20.0003 12.6667C19.6321 12.6667 19.3337 12.3682 19.3337 12C19.3337 11.6318 19.6321 11.3333 20.0003 11.3333C20.3685 11.3333 20.667 11.6318 20.667 12Z"
    fill="#47675B"
  />
  <path
    d="M12.667 12C12.667 12.3682 12.3685 12.6667 12.0003 12.6667C11.6321 12.6667 11.3337 12.3682 11.3337 12C11.3337 11.6318 11.6321 11.3333 12.0003 11.3333C12.3685 11.3333 12.667 11.6318 12.667 12Z"
    fill="#47675B"
  />
  <path
    d="M10.667 18.6667C10.667 18.6667 12.667 21.3333 16.0003 21.3333C19.3337 21.3333 21.3337 18.6667 21.3337 18.6667M20.0003 12H20.0137M12.0003 12H12.0137M29.3337 16C29.3337 23.3638 23.3641 29.3333 16.0003 29.3333C8.63653 29.3333 2.66699 23.3638 2.66699 16C2.66699 8.63621 8.63653 2.66667 16.0003 2.66667C23.3641 2.66667 29.3337 8.63621 29.3337 16ZM20.667 12C20.667 12.3682 20.3685 12.6667 20.0003 12.6667C19.6321 12.6667 19.3337 12.3682 19.3337 12C19.3337 11.6318 19.6321 11.3333 20.0003 11.3333C20.3685 11.3333 20.667 11.6318 20.667 12ZM12.667 12C12.667 12.3682 12.3685 12.6667 12.0003 12.6667C11.6321 12.6667 11.3337 12.3682 11.3337 12C11.3337 11.6318 11.6321 11.3333 12.0003 11.3333C12.3685 11.3333 12.667 11.6318 12.667 12Z"
    stroke="#F2F7F5"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
